import TextField from "@mui/material/TextField";
import useHttp from "../hooks/useHttp";
import {useState} from 'react';
import {authActions} from "../store/authSlice";
import {useDispatch} from "react-redux";
import Button from "@mui/material/Button";

function SignIn(){
    const [email, setEmail] =  useState('');
    const [password, setPassword] = useState('')

    const dispatch = useDispatch()
    function logUser(user){
        console.log(user)
        dispatch(authActions.setCredentials(user))
    }

    function emailChangeHandler(e){
        setEmail(e.target.value)
    }

    function passwordChangeHandler(e){
        setPassword(e.target.value)
    }

    function signInHandler(e){
        e.preventDefault();
        console.log(email);
        console.log(password)
        sendRequest()
    }


    const {isLoading, error, sendRequest} = useHttp({
        url: 'https://hub.northq.com/o/token/',
        method: 'POST',
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            "username": email,
            "password": password,
            "grant_type": "password",
            "client_id": "3CFutBYL9CJOKVQGBHTQgIwNTuW0P8fOoDHL85FT"}).toString()
    }, logUser)


    return(
        <div>
            <form onSubmit={signInHandler}>
                <TextField onChange={emailChangeHandler} value={email} label='E-mail'></TextField>
                <TextField onChange={passwordChangeHandler} value={password} label='Password' type='password'></TextField>
                <Button type="submit">Sign in</Button>
            </form>
        </div>
    )
}

export default SignIn